import { CalendarProvider } from '@features/calendar/components/CalendarContext'
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/calendar/_view')({
    component: RouteComponent,
})

function RouteComponent() {

    const navigate = useNavigate()

    return (
        <CalendarProvider onViewChange={(view) => navigate({ to: `/calendar/${view}` })}>
            <Outlet />
        </CalendarProvider>
    )
}
